import { useState } from 'react';
import { OffsegAuthInfoType } from '../../feature/type/AuthInfoType';
import { initOffsegAuthInfo } from '../../../common/const/commonConst';

type InputType = {
	setIsLoginError: (value: React.SetStateAction<boolean>) => void;
	setNeedsChangeInitPassword: (value: React.SetStateAction<boolean>) => void;
	setIsLoginLockError: (value: React.SetStateAction<boolean>) => void;
	setIsLocalStorageError: (value: React.SetStateAction<boolean>) => void;
	setOffsegReregistrationAuthInfo: (value: React.SetStateAction<OffsegAuthInfoType>) => void;
};

/**
 * G500Liteログイン情報再登録STEP1ダイアログの状態管理用カスタムフック
 */
export const useStateReregistrationStep1Dialog = (input: InputType) => {
	const { setIsLoginError, setNeedsChangeInitPassword, setIsLoginLockError, setIsLocalStorageError, setOffsegReregistrationAuthInfo } = input;

	const [isReregistrationDialogStep1Opened, setIsReregistrationDialogStep1Opened] = useState(false); // G500Liteログイン情報再登録ダイアログStep1の開閉状態の管理

	// ログイン情報再登録のリンクを押下した際の処理
	const onClickReregistrationLink = () => {
		setIsLoginError(false);
		setNeedsChangeInitPassword(false);
		setIsLoginLockError(false);
		setIsLocalStorageError(false);
		setIsReregistrationDialogStep1Opened(true);
	};

	//ログイン情報再登録ダイアログSTEP1を閉じる際の処理
	const onCloseReregistrationDialogStep1 = () => {
		setIsLoginError(false);
		setNeedsChangeInitPassword(false);
		setIsLoginLockError(false);
		setIsLocalStorageError(false);
		setIsReregistrationDialogStep1Opened(false);
		setOffsegReregistrationAuthInfo(initOffsegAuthInfo);
	};

	return {
		isReregistrationDialogStep1Opened,
		setIsReregistrationDialogStep1Opened,
		onClickReregistrationLink,
		onCloseReregistrationDialogStep1,
	};
};
